// extracted by mini-css-extract-plugin
export default {"error404":"Error404_error404__36WVA","wrapper":"Error404_wrapper__X3i8u"};